var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAllErrorMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96763 0.25C3.51647 0.25 0.71875 3.04772 0.71875 6.49888C0.71875 9.95004 3.51647 12.7478 6.96763 12.7478C10.4188 12.7478 13.2165 9.95004 13.2165 6.49888C13.2165 3.04772 10.4188 0.25 6.96763 0.25ZM6.21765 9C6.21765 8.58579 6.55344 8.25 6.96765 8.25H6.97223C7.38645 8.25 7.72223 8.58579 7.72223 9V9.00458C7.72223 9.4188 7.38645 9.75458 6.97223 9.75458H6.96765C6.55344 9.75458 6.21765 9.4188 6.21765 9.00458V9ZM7.71765 3.9502C7.71765 3.53598 7.38187 3.2002 6.96765 3.2002C6.55344 3.2002 6.21765 3.53598 6.21765 3.9502V6.7502C6.21765 7.16441 6.55344 7.5002 6.96765 7.5002C7.38187 7.5002 7.71765 7.16441 7.71765 6.7502V3.9502Z",
    fill: "#B4371B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAllErrorMessage);
export default __webpack_public_path__ + "static/media/download-all-error-message.024169e906b4f8de4ee4663167976fc2.svg";
export { ForwardRef as ReactComponent };